<template>
  <v-card elevation="0">
    <v-card-title>내 일정</v-card-title>
    <v-card-text>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            21/05/10 14:00~15:00 SPREAD 사용자 교육
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            21/05/11 10:00~12:00 DSKN 유지보수 회의
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            21/05/17 13:00~14:00 기획팀 회의
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
